import { createContext } from 'react';

import { ListItemNode_Node } from './__generated__/ListItemNode_Node.graphql';
import { Audit } from './types/auditType';

export type Node = ListItemNode_Node & {
  _id: string;
  name?: string | null;
  nameJson?: any | null;
  [key: string]: any;
};

export interface ListNodesContextProps {
  idsSelected?: string[];
  idsChecked?: string[];
  onNodeSelected?: (event: React.UIEvent | React.SyntheticEvent, node: Node | Audit) => void;
  onNodesChecked?: (event: React.UIEvent | React.SyntheticEvent, ids: string[]) => void;
}

export const ListNodesContext = createContext<ListNodesContextProps>({});

if (process.env.NODE_ENV !== 'production') {
  ListNodesContext.displayName = 'ListNodesContext';
}

export default ListNodesContext;
